import React from 'react';
import moment from 'moment';
import { Col } from 'antd';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import TimePickerField from '../../../../common/formComponents/TimePickerField/TimePickerField';
import {
  fieldNames,
  timePickerProps,
  HOUR_INTERVAL_ID,
  defaultDate,
} from '../constants';

const LunchTimeFieldRow = ({ form, checkMinutesMatchInterval }) => {
  const { getFieldValue, setFieldsValue, validateFields } = form;

  const intervalIdVal = form.getFieldValue(fieldNames.intervalId);
  const minuteStep = intervalIdVal === HOUR_INTERVAL_ID ? 60 : 30;

  const periodValidator = (_rule, value, callback) => {
    const startTime = getFieldValue(fieldNames.startTime);
    const endTime = getFieldValue(fieldNames.endTime);

    if (value && startTime && endTime) {
      const startTimeFormat = startTime.format('HH:mm');
      const endTimeFormat = endTime.format('HH:mm');
      const lunchTimeFormat = value.format('HH:mm');

      const startDate = moment(`${defaultDate} ${startTimeFormat}`);
      const endDate = moment(`${defaultDate} ${endTimeFormat}`);
      const lunchDate = moment(`${defaultDate} ${lunchTimeFormat}`);

      if (!lunchDate.isBetween(startDate, endDate)) {
        return callback(
          'Обеденный перерыв должен быть в интервале рабочего времени'
        );
      }
    }

    return callback();
  };

  const handleChange = (time, timeString, fieldName) => {
    if (time) {
      const lunchStartTime = getFieldValue(fieldNames.lunchStartTime);
      const lunchEndTime = getFieldValue(fieldNames.lunchEndTime);

      if (fieldName === fieldNames.lunchStartTime && lunchEndTime) {
        const startDate = moment(`${defaultDate} ${timeString}`);
        const endDate = moment(
          `${defaultDate} ${lunchEndTime.format('HH:mm')}`
        );

        if (startDate.isSameOrAfter(endDate)) {
          setFieldsValue({
            [fieldNames.lunchEndTime]: time.clone().add(1, 'hours'),
          });

          validateFields([fieldNames.lunchEndTime], { force: true });
        }
      }

      if (fieldName === fieldNames.lunchEndTime && lunchStartTime) {
        const startDate = moment(
          `${defaultDate} ${lunchStartTime.format('HH:mm')}`
        );
        const endDate = moment(`${defaultDate} ${timeString}`);

        if (startDate.isSameOrAfter(endDate)) {
          setFieldsValue({
            [fieldNames.lunchStartTime]: time.clone().subtract(1, 'hours'),
          });

          validateFields([fieldNames.lunchStartTime], { force: true });
        }
      }
    }
  };

  const inputProps = {
    ...timePickerProps,
    minuteStep,
  };

  return (
    <FormRow type="flex" gutter={20}>
      <Col span={12}>
        <TimePickerField
          form={form}
          label="Начало обеденного перерыва"
          name={fieldNames.lunchStartTime}
          options={{
            initialValue: moment(`13:00`, 'HH:mm'),
            rules: [
              {
                type: 'object',
                required: true,
                message: 'Укажите начало обеденного перерыва',
              },
              {
                validator: checkMinutesMatchInterval,
              },
              {
                validator: periodValidator,
              },
            ],
          }}
          inputProps={{
            ...inputProps,
            onChange: (time, timeString) =>
              handleChange(time, timeString, fieldNames.lunchStartTime),
          }}
        />
      </Col>
      <Col span={12}>
        <TimePickerField
          form={form}
          label="Конец обеденного перерыва"
          name={fieldNames.lunchEndTime}
          options={{
            initialValue: moment(`14:00`, 'HH:mm'),
            rules: [
              {
                type: 'object',
                required: true,
                message: 'Укажите конец обеденного перерыва',
              },
              {
                validator: checkMinutesMatchInterval,
              },
              {
                validator: periodValidator,
              },
            ],
          }}
          inputProps={{
            ...inputProps,
            onChange: (time, timeString) =>
              handleChange(time, timeString, fieldNames.lunchEndTime),
          }}
        />
      </Col>
    </FormRow>
  );
};

export default LunchTimeFieldRow;
